var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        {
          ref: "newComment",
          attrs: {
            model: _vm.newComment,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          this.$store.state.session.sessionId === "GUEST"
            ? _c(
                "q-form-item",
                {
                  attrs: {
                    label: this.$qt("post.comment.rules.name.text"),
                    prop: "name",
                  },
                },
                [
                  _c("q-input", {
                    model: {
                      value: _vm.newComment.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.newComment, "name", $$v)
                      },
                      expression: "newComment.name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "q-form-item",
            {
              attrs: {
                label: this.$qt("post.comment.rules.phone.text"),
                prop: "phone",
              },
            },
            [
              _c("q-input", {
                model: {
                  value: _vm.newComment.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.newComment, "phone", $$v)
                  },
                  expression: "newComment.phone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            {
              attrs: {
                label: this.$qt("post.comment.rules.email.text"),
                prop: "email",
              },
            },
            [
              _c("q-input", {
                model: {
                  value: _vm.newComment.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.newComment, "email", $$v)
                  },
                  expression: "newComment.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            {
              attrs: {
                label: this.$qt("post.comment.rules.note.text"),
                prop: "note",
              },
            },
            [
              _c("q-input", {
                attrs: { rows: 7, type: "textarea" },
                model: {
                  value: _vm.newComment.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.newComment, "note", $$v)
                  },
                  expression: "newComment.note",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-form-item",
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("newComment")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("post.comment.sendButtonText")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("newComment")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("post.comment.resetButtonText")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }